module.exports = __webpack_public_path__ + "static/img/case_pro3.11ad8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case_pro3.jpg
// module id = fLF2
// module chunks = 1